export default __webpack_public_path__ + "static/media/i_bus-gen_yl.bf6ed0c2.svg";